/**
 * Race a promise against a timeout. Rejects with an Error whose name is 'TimeoutError'.
 */
export const withTimeout = (promise, ms, label = 'operation') => {
  let timeoutId;
  const timeoutPromise = new Promise((_, reject) => {
    timeoutId = setTimeout(() => {
      const err = new Error(`${label} timed out after ${ms}ms`);
      err.name = 'TimeoutError';
      reject(err);
    }, ms);
  });

  return Promise.race([promise, timeoutPromise]).finally(() => {
    clearTimeout(timeoutId);
  });
};

export const COLD_PATH_TIMEOUT_MS = 3000;
